var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"label":"Full Name"}},[_c('b-form-input',{class:{
          'is-valid': !_vm.$v.section.childFullname.$error && _vm.section.childFullname,
          'is-invalid': _vm.$v.section.childFullname.$error 
        },attrs:{"value":_vm.section.childFullname},on:{"input":function($event){return _vm.handleInput('childrenDetails', $event, false, true, _vm.index, `childFullname`)}}})],1),_c('b-form-group',{attrs:{"label":"Date of Birth"}},[_c('b-form-input',{class:{
          'is-valid': !_vm.$v.section.childDOB.$error && _vm.section.childDOB,
          'is-invalid': _vm.$v.section.childDOB.$error 
        },attrs:{"type":"date","value":_vm.section.childDOB},on:{"input":function($event){return _vm.handleInput('childrenDetails', $event, false, true, _vm.index, `childDOB`)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }